import { render, staticRenderFns } from "./WafRuleStatement.vue?vue&type=template&id=0f021a84"
import script from "./WafRuleStatement.vue?vue&type=script&lang=js"
export * from "./WafRuleStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports